import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import { Button } from 'gdpp-components/dist/cjs/components/atoms'

import useComponentVisible from '../../hoc/useComponentVisible'

import './style.scss'

// Reference: http://design-fidelity-gds-prod.fil.aldryn.io/components/dropdown/#develop
const Dropdown = ({ id, size, menu, label, icon, kind, alignment, filled, iconPosition, iconSize, extraClasses, target }) => {
  const { ref, isComponentVisible, setIsComponentVisible } = useComponentVisible(false)

  const clickHandler = () => {
    setIsComponentVisible(!isComponentVisible)
  }

  const dropdownHandler = (event) => {
    event.stopPropagation()
  }

  const linkClickHandler = (item) => {
    if (item.click) {
      item.click(item)
    }
    clickHandler()
  }

  const classes = {
    'fil-dropdown-wrapper': true,
    [`fil-dropdown-wrapper--${size}`]: size,
    'fil-dropdown--open': isComponentVisible,
    [`fil-dropdown--${alignment}`]: alignment,
    hide: !menu.length,
    [extraClasses]: extraClasses
  }

  return (
    <div id={id} ref={ref} className={classnames(classes)} onClick={dropdownHandler}>
      <Button
        label={label}
        kind={kind}
        size={size}
        iconPosition={iconPosition}
        aria-labelledby={id}
        iconSize={iconSize}
        onClick={clickHandler}
        aria-haspopup="listbox"
        {...(icon ? { icon: Array.isArray(icon) ? (isComponentVisible ? icon[0] : icon[1]) : icon } : {})}
        {...(filled ? { filled } : {})}
      />
      <ul id={`${id}-dropdown-menu`} className="fil-dropdown-menu" role="listbox">
        {menu.map((link, index) => {
          return (
            <li
              id={`${id}-dropdown-menu-options-${index}`}
              key={`fil-dropdown-options-${index}`}
              className={link.className ? link.className : ''}
            >
              <a
                className="fil-dropdown-menu--link"
                {...(link.title ? { title: link.title } : {})}
                {...(link.href ? { href: link.href } : {})}
                onClick={() => {
                  linkClickHandler(link)
                }}
                target={target}
              >
                {link.icon && <fil-icon icon={link.icon} />} <span>{link.title}</span>
              </a>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

Dropdown.propTypes = {
  id: PropTypes.string.isRequired,
  menu: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      href: PropTypes.string,
      icon: PropTypes.string,
      className: PropTypes.string,
      click: PropTypes.func
    })
  ).isRequired,
  size: PropTypes.string,
  label: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  kind: PropTypes.string,
  alignment: PropTypes.string,
  filled: PropTypes.bool,
  iconPosition: PropTypes.string,
  iconSize: PropTypes.number,
  extraClasses: PropTypes.string,
  target: PropTypes.string
}

Dropdown.defaultProps = {
  size: 'standard',
  label: '',
  icon: '',
  kind: 'secondary',
  alignment: 'left',
  filled: false,
  iconPosition: 'right',
  iconSize: 12,
  extraClasses: '',
  target: '_blank'
}

export default Dropdown
